import React from "react";
import { Button, Col, Result, Row } from "antd";
import { FormattedMessage } from "react-intl";

function Error404Page() {
  return (
    <Row justify="space-around">
      <Col>
        <Result
          status="404"
          title="404"
          subTitle={
            <FormattedMessage
              description="404 page message"
              defaultMessage="Sorry, the page you visited does not exist."
            />
          }
          extra={
            <Button type="primary" href="/">
              <FormattedMessage
                description="404 page back home button"
                defaultMessage="Back Home"
              />
            </Button>
          }
        />
      </Col>
    </Row>
  );
}

export default Error404Page;
